var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('v-tabs-items',{staticClass:"overflow-auto fill-height",model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},_vm._l((_vm.accountOpenSteps),function(accountStep,i){return _c('v-tab-item',{key:i,staticClass:"fill-height"},[_c(accountStep.component,{tag:"component"})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }